module.exports = __webpack_public_path__ + "static/media/icon_package.8fcf67d6.svg";